// // ================================
// // PINCODE CHECKER (AJAX SAFE)
// // ================================

// (function ($) {
//   if (!$) return;

//   const API_URL =
//     "https://script.google.com/macros/s/AKfycby2qL1P5dD2iTLCd_W53MdC-DoSkNBUNmMDuwQPMZqbVEogI1_PWSPtqcWUBH5r9KVc/exec";

//   const pincodeCache = {};

//   function formatShortDate(dateStr) {
//     if (!dateStr) return "";
//     return dateStr.split(", ")[1];
//   }

//   // 🔥 EVENT DELEGATION (THIS IS THE FIX)
//   $(document).on("click", ".delivery-checker__check-btn", function (e) {
//     e.preventDefault();

//     const $button = $(this);
//     const $section = $button.closest(".delivery-checker");

//     if (!$section.length) return;

//     const $input = $section.find(".delivery-checker__input");
//     const $dateEl = $section.find(".delivery-checker__date");
//     const $result = $section.find(".delivery-checker__result");
//     const $cash = $section.find(".delivery-checker__info-item");
//     const $label = $section.find(".delivery-checker__label");
//     const $dicon = $section.find(".delivery-icon");
//     const $errormsg = $section.find(".error_message");

//     const pincode = $.trim($input.val());

//     // Reset UI
//     $result.show();
//     $cash.hide();
//     $label.hide();
//     $dicon.hide();
//     $errormsg.hide();
//     $dateEl.text("");
//     $input.css("border", "1px solid #dcdcdc");

//     // Validation
//     if (!/^\d{6}$/.test(pincode)) {
//       $errormsg.text("Please enter a valid 6-digit pincode").show();
//       $input.css("border", "1px solid red");
//       return;
//     }

//     // Cache check
//     if (
//       pincodeCache[pincode] &&
//       pincodeCache[pincode].expectedDateMin &&
//       pincodeCache[pincode].expectedDateMax
//     ) {
//       const cached = pincodeCache[pincode];

//       $label.text("Estimated delivery date by").show();
//       $dicon.show();

//       $dateEl.text(
//         formatShortDate(cached.expectedDateMin) +
//           " - " +
//           formatShortDate(cached.expectedDateMax)
//       );

//       $cash.show();
//       return;
//     }

//     // Loading state
//     $button.prop("disabled", true).addClass("is-loading");
//     $input.prop("disabled", true);

//     $label.text("Estimated delivery date by").show();
//     $dicon.show();
//     $dateEl.html('<span class="loader"></span> Checking...');

//     // API call
//     $.ajax({
//       url: API_URL,
//       method: "GET",
//       data: { pincode },
//       dataType: "json",

//       success: function (data) {
//         if (data.expectedDateMin && data.expectedDateMax) {
//           pincodeCache[pincode] = data;

//           $dateEl.text(
//             formatShortDate(data.expectedDateMin) +
//               " - " +
//               formatShortDate(data.expectedDateMax)
//           );

//           $cash.show();
//         } else {
//           delete pincodeCache[pincode];
//           $dateEl.text("");
//           $label.text("Delivery not available").show();
//           $cash.hide();
//         }
//       },

//       error: function () {
//         delete pincodeCache[pincode];
//         $dateEl.text("");
//         $label.text("Delivery not available").show();
//         $cash.hide();
//       },

//       complete: function () {
//         $button.prop("disabled", false).removeClass("is-loading");
//         $input.prop("disabled", false);
//       }
//     });
//   });
// })(window.jQuery);



// ================================
// PINCODE CHECKER (VANILLA JS)
// ================================

(function () {
  console.log("[Pincode Checker] Initialized");

  const API_URL =
    "https://script.google.com/macros/s/AKfycby2qL1P5dD2iTLCd_W53MdC-DoSkNBUNmMDuwQPMZqbVEogI1_PWSPtqcWUBH5r9KVc/exec";

  const pincodeCache = {};

  function show(el, flex = false) {
    if (el) {
      el.style.display = flex ? "flex": "block";
    }
  }

  function hide(el) {
    if (el) {
      el.style.display = "none";
    }
  }

  function formatShortDate(dateStr) {
    console.log("[formatShortDate] Raw:", dateStr);

    if (!dateStr) return "";

    const formatted = dateStr.split(", ")[1] || dateStr;

    console.log("[formatShortDate] Formatted:", formatted);

    return formatted;
  }

  // Event Delegation (AJAX Safe)
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".delivery-checker__check-btn");

    if (!button) return;

    e.preventDefault();

    console.log("[Click] Check Button Clicked");

    const section = button.closest(".delivery-checker");

    if (!section) {
      console.warn("[Error] .delivery-checker not found");
      return;
    }

    const input = section.querySelector(".delivery-checker__input");
    const dateEl = section.querySelector(".delivery-checker__date");
    const result = section.querySelector(".delivery-checker__result");
    const cash = section.querySelector(".delivery-checker__info-item");
    const label = section.querySelector(".delivery-checker__label");
    const dicon = section.querySelector(".delivery-icon");
    const errormsg = section.querySelector(".error_message");

    const pincode = input ? input.value.trim() : "";

    console.log("[Input] Pincode:", pincode);

    // Reset UI
    console.log("[UI] Resetting");

    show(result, true);
    hide(cash);
    hide(label);
    hide(dicon);
    hide(errormsg);

    if (dateEl) {
      dateEl.textContent = "";
    }

    if (input) {
      input.style.border = "1px solid #dcdcdc";
    }

    // Validation
    if (!/^\d{6}$/.test(pincode)) {
      console.warn("[Validation] Invalid Pincode");

      if (errormsg) {
        errormsg.textContent = "Please enter a valid 6-digit pincode";
        show(errormsg);
      }

      if (input) {
        input.style.border = "1px solid red";
      }

      return;
    }

    console.log("[Validation] Passed");

    // Cache Check
    if (
      pincodeCache[pincode] &&
      pincodeCache[pincode].expectedDateMin &&
      pincodeCache[pincode].expectedDateMax
    ) {
      console.log("[Cache] Hit", pincode);

      const cached = pincodeCache[pincode];

      if (label) {
        label.textContent = "Estimated delivery date by";
        show(label);
      }

      show(dicon);

      if (dateEl) {
        dateEl.textContent =
          formatShortDate(cached.expectedDateMin) +
          " - " +
          formatShortDate(cached.expectedDateMax);
      }

      show(cash);

      return;
    }

    console.log("[Cache] Miss", pincode);

    // Loading State
    button.disabled = true;
    button.classList.add("is-loading");

    if (input) {
      input.disabled = true;
    }

    if (label) {
      label.textContent = "Estimated delivery date by";
      show(label);
    }

    show(dicon);

    if (dateEl) {
      dateEl.innerHTML = '<span class="loader"></span> Checking...';
    }

    const url =
      API_URL + "?pincode=" + encodeURIComponent(pincode);

    console.log("[API] Request URL:", url);

    fetch(url, {
      method: "GET"
    })
      .then(function (response) {
        console.log("[API] Status:", response.status);

        if (!response.ok) {
          throw new Error("HTTP Error: " + response.status);
        }

        return response.json();
      })
      .then(function (data) {
        console.log("[API] Response:", data);

        if (data.expectedDateMin && data.expectedDateMax) {
          console.log("[Success] Delivery Available");

          pincodeCache[pincode] = data;

          console.log(
            "[Cache] Saved:",
            pincodeCache[pincode]
          );

          if (dateEl) {
            dateEl.textContent =
              formatShortDate(data.expectedDateMin) +
              " - " +
              formatShortDate(data.expectedDateMax);
          }

          show(cash);
        } else {
          console.warn("[API] Delivery Not Available");

          delete pincodeCache[pincode];

          if (dateEl) {
            dateEl.textContent = "";
          }

          if (label) {
            label.textContent = "Delivery not available";
            show(label);
          }

          hide(cash);
        }
      })
      .catch(function (error) {
        console.error("[API Error]", error);

        delete pincodeCache[pincode];

        if (dateEl) {
          dateEl.textContent = "";
        }

        if (label) {
          label.textContent = "Delivery not available";
          show(label);
        }

        hide(cash);
      })
      .finally(function () {
        console.log("[UI] Loading Complete");

        button.disabled = false;
        button.classList.remove("is-loading");

        if (input) {
          input.disabled = false;
        }
      });
  });
})();